import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid, User, Sparkles, LogOut } from "lucide-react";
import { useMemberAuth } from "../../context/MemberAuthContext";
import { ASSETS } from "../../data";

const LINKS = [
  { to: "/portal", label: "Dashboard", icon: LayoutGrid, testid: "portal-nav-dashboard" },
  { to: "/portal/account", label: "My Account", icon: User, testid: "portal-nav-account" },
  { to: "/portal/done-for-you", label: "Done For You", icon: Sparkles, testid: "portal-nav-dfy" },
];

export const PortalNav = () => {
  const { logout } = useMemberAuth();
  const loc = useLocation();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#050505]/90 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/portal" data-testid="portal-logo" className="flex items-center gap-3">
          <img src={ASSETS.logo} alt="Ghost The Grid" className="h-8 w-8 object-cover rounded-sm" />
          <span className="hidden sm:inline font-display font-extrabold uppercase tracking-tight text-sm">Member Portal</span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          {LINKS.map(({ to, label, icon: Icon, testid }) => {
            const active = loc.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                data-testid={testid}
                className={`flex items-center gap-2 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.15em] transition-colors ${
                  active ? "text-accent" : "text-white/50 hover:text-white"
                }`}
              >
                <Icon size={14} />
                <span className="hidden sm:inline">{label}</span>
              </Link>
            );
          })}
          <button
            data-testid="portal-logout-button"
            onClick={() => { logout(); nav("/portal/login"); }}
            className="flex items-center gap-2 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-white/50 hover:text-accent transition-colors"
          >
            <LogOut size={14} />
            <span className="hidden sm:inline">Log out</span>
          </button>
        </nav>
      </div>
    </header>
  );
};
